module.exports = __webpack_public_path__ + "img/question@2x.fcdef7ff.png";